// Active account — the client-side signal every account-scoped query keys on.
//
// GitHub-style multi-org: a signed-in user belongs to many accounts (their
// personal one + orgs) and acts as exactly ONE at a time. Since #460 the org
// lives in the URL (`/org/<login>/…`): `OrgScope` mirrors the URL segment into
// this signal, so flipping orgs (the switcher NAVIGATES, it no longer mutates
// the session) changes every account-scoped query key — TanStack refetches
// under the new tenant and never bleeds one org's cached data into another's
// view. Per-request, the org rides as the `X-Dz-Account` header (lib/api.ts),
// membership-validated server-side (`apps/api/src/middleware/auth.ts`).
//
// Null outside an `/org/:org` route: queries then key on "the server default"
// (the session's active account — `POST /v1/me/active-account` remains as the
// server-side fallback/backcompat pointer, out of the dashboard's normal flow).

import { createSignal } from 'solid-js';

const [activeAccountId, setActiveAccountId] = createSignal<string | null>(null);

/**
 * The account (URL org segment) every account-scoped query keys on. Read it
 * inside a query's `queryKey` (a reactive context) so an org change re-keys and
 * refetches; set only by `OrgScope`, which derives it from the URL.
 */
export { activeAccountId, setActiveAccountId };
